const url = '/v1/pub/confirmar_novo_email/:cid';

const applet = '/p/confirmar';

const view = `${applet}/email/:cid`;

export { url, applet, view };
